import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearCheckoutIntent, takeCheckoutReturn } from '../../../utils/helper/checkout';
import { GetToken } from '../../../utils/helper/helper';

/**
 * Landing page for the Back button on the Stripe form - a redirect, not a page.
 *
 * Every checkout shares this one cancel_url (see saveCheckoutReturn in checkout.js for why it
 * cannot vary), so it used to announce "Payment cancelled" and send everyone to /Home, whichever
 * page they had started from. Pressing Back is not a failure worth a message: it goes straight
 * back to the route startCheckout remembered.
 *
 * Nothing is remembered when Stripe was opened from another tab, storage was blocked, or the
 * session predates this change; a signed-in player then lands on Account Settings, where a plan
 * can be bought, and anyone else on Home.
 */
export const PaymentCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Deliberately abandoned, so it must not be relaunched at the next sign-in.
    clearCheckoutIntent();

    const isPlayer = GetToken() && localStorage.getItem('role') === 'Player';
    const fallback = isPlayer ? '/Player/Account_settings' : '/Home';

    // Replace, so the browser's own Back does not return here and bounce into Stripe again.
    navigate(takeCheckoutReturn() || fallback, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
